<section class="mission" [attr.aria-label]="'ABOUT-US_MISSION-HEADING' | translate">
  <div class="mission__layout">
    <p class="mission__statement">{{ 'ABOUT-US_MISSION-CONTENT-APPROVED' | translate }}</p>

    <figure class="mission__figure">
      <div class="mission__image-frame">
        <img
          src="assets/images/about-us/haiti-2010-nadav-neuhaus.jpg"
          [alt]="'ABOUT-US_MISSION-PHOTO-ALT' | translate"
        />
      </div>
      <figcaption>{{ 'ABOUT-US_MISSION-PHOTO-CREDIT' | translate }}</figcaption>
    </figure>
  </div>
</section>
